import { FlatList, TouchableOpacity } from 'react-native'
import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { DefaultTheme } from 'styled-components/native'

export const LIST_ITEM_MARGIN = ({ theme }: { theme: DefaultTheme }) =>
  theme.metrics.baseMargin * 0.75

export const StyledHeaderContainer = styled.View`
  flex-direction: row;
  align-items: center;
  margin-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const StyledHeaderText = styled(Typography).attrs(() => ({
  variant: 'h3',
}))`
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.text};
`

export const StyledScrollLeftButton = styled(TouchableOpacity).attrs(() => ({
  accessibilityRole: 'button',
}))`
  padding: ${({ theme }) => theme.metrics.baseMargin * 0.65}px;
`

export const StyledScrollRightButton = styled(TouchableOpacity).attrs(() => ({
  accessibilityRole: 'button',
}))`
  padding: ${({ theme }) => theme.metrics.baseMargin * 0.65}px;
`

export const StyledFlatList = styled(FlatList).attrs(() => ({
  accessibilityRole: 'list',
}))`
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
`
